import React, { useCallback, useEffect, useState } from "react";

type WorkdPressPost = {
  id: number;
  date: string;
  date_gmt: string;
  guid: {
    rendered: string;
  };
  modified: string;
  modified_gmt: string;
  slug: string;
  status: string;
  type: string;
  link: string;
  title: {
    rendered: string;
  };
  contend: {
    rendered: string;
    protected: boolean;
  };
  excerpt: {
    rendered: string;
    protected: boolean;
  };
  author: number;
  featured_media: number;
  comment_status: string;
  ping_status: string;
  sticky: boolean;
  template: string;
  format: string;
  meta: unknown[];
  categories: number[];
  tags: string[];
};

type NewsLink = {
  title: string;
  href: string;
};

const News = () => {
  const [newsList, setNewsList] = useState<NewsLink[]>([]);
  const [index, setIndex] = useState(-1);
  const onTransitionEnd = useCallback(() => {
    setIndex((oldIndex) => (oldIndex + 1) % newsList.length);
  }, [newsList]);
  useEffect(() => {
    if (newsList.length > 0) {
      return;
    }
    fetch("https://techsource.site//wp-json/wp/v2/posts?per_page=5")
      .then((response) => {
        return response.json();
      })
      .then((data: WorkdPressPost[]) => {
        setNewsList(
          data.map((datum) => ({
            title: datum.title.rendered,
            href: datum.link,
          }))
        );
        setIndex(0);
      });
  }, [newsList]);
  return (
    <div id="news">
      <div className="title">最近のTechSource:</div>
      <div id="div_ticker4" className="tick">
        {index >= 0 && (
          <a
            href={newsList[index].href}
            onAnimationIteration={onTransitionEnd}
            className="news"
          >
            {newsList[index].title}
          </a>
        )}
      </div>
    </div>
  );
};

export default News;
